import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

//services
import { login } from '../api';

export const useMutationLogin = ({ setTokens }) => {
  const { t } = useTranslation();

  const userActivationString = 'User not yet activated.';

  const { mutate, status, error } = useMutation(login, {
    onSuccess: data => {
      setTokens(data.data.accessToken, data.data.refreshToken);
    },
    onError: (errorValue, { formik }) => {
      const userActivationMessage = errorValue?.response?.data?.errorDescription;

      formik.setErrors({
        field_a: 'The email or password is incorrect. Please try again.',
        b_temp_pwd: 'The email or password is incorrect. Please try again.',
        isAccountConfirmed: userActivationMessage === userActivationString ? false : true,
      });
    },
  });

  return {
    mutate,
    status,
    error,
  };
};
